import { render, staticRenderFns } from "./CasePulse.vue?vue&type=template&id=fa8658e0&"
import script from "./CasePulse.vue?vue&type=script&lang=js&"
export * from "./CasePulse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CasePulse.vue"
export default component.exports